export default "<p>\n  ambulance-view works!\n</p>\n"